import React from 'react';

import classnames from 'classnames';
import { Link } from 'react-router-dom';
import { Alert, CircularProgress } from '@mui/material';
import { WHITELABEL_SETTINGS } from '../../constants/config';

export default function HomeDecorator(content, errorMessage, isLoading) {
  return (
    <div className="home-decorator">
      <div className="decorator-container">
        <Link to="/" className="logo-link" tabIndex={-1}>
          <img alt="logo" height={47} src={`${WHITELABEL_SETTINGS.brand.logoPortrait}`} />
        </Link>
        <div className="LoginView">
          {isLoading && (
            <div className="login-loader">
              <CircularProgress color="secondary" />
            </div>
          )}
          {content}
        </div>
        {!!errorMessage ? (
          <Alert
            data-testid="error-message"
            variant="filled"
            severity="error"
            sx={{ width: '400px' }}
          >
            {errorMessage}
          </Alert>
        ) : null}
      </div>
    </div>
  );
}
